import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { matchRoutePermission } from "../../config/navPermissions";
import { evaluatePermissionAccess } from "../../hooks/usePermissionAccess";
import { SESSION_STORAGE_HYDRATED_EVENT } from "../../hooks/use-navigation";

/** Layout-level gate: mirrors sidebar permission rules for direct URL access. */
export const PermissionGate = ({ children }) => {
    const location = useLocation();
    const [, setHydrationTick] = useState(0);

    useEffect(() => {
        const onHydrated = () => setHydrationTick((n) => n + 1);
        window.addEventListener(SESSION_STORAGE_HYDRATED_EVENT, onHydrated);
        window.addEventListener("storage", onHydrated);
        return () => {
            window.removeEventListener(SESSION_STORAGE_HYDRATED_EVENT, onHydrated);
            window.removeEventListener("storage", onHydrated);
        };
    }, []);

    const spec = matchRoutePermission(location.pathname);
    const allowed = evaluatePermissionAccess(spec);

    if (!allowed) {
        return <Navigate to="/home" replace />;
    }

    return (
        <div className="flex flex-1 flex-col min-h-0">
            {children}
        </div>
    );
};

/** NABH feature flag — re-reads session after dashboard hydration. */
export const TrainingGuard = ({ children }) => {
    const [, setHydrationTick] = useState(0);

    useEffect(() => {
        const onHydrated = () => setHydrationTick((n) => n + 1);
        window.addEventListener(SESSION_STORAGE_HYDRATED_EVENT, onHydrated);
        window.addEventListener("storage", onHydrated);
        return () => {
            window.removeEventListener(SESSION_STORAGE_HYDRATED_EVENT, onHydrated);
            window.removeEventListener("storage", onHydrated);
        };
    }, []);

    const customConfig = JSON.parse(sessionStorage.getItem("customConfig") || "{}");
    if (!customConfig.is_nabh) {
        return <Navigate to="/home" replace />;
    }
    return children;
};

/** Declarative wrapper for individual routes (optional — PermissionGate covers most). */
export const PermissionRouteGuard = ({ spec, children }) => {
    const allowed = evaluatePermissionAccess(spec);
    if (!allowed) {
        return <Navigate to="/home" replace />;
    }
    return children;
};
